module.exports = __webpack_public_path__ + "img/business-img.1f48727d.png";